export default __webpack_public_path__ + "static/esa-bd54630d3c4a72d66a1917677727dff9.png";